import { AlphaPCircleIcon } from './AlphaPCircleIcon';

/**
 * author: Contributors
 * id 172BAE9F-C813-407E-A1D0-CBB548C3F9D8
 * name alpha-p-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-p-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterPCircleIcon = AlphaPCircleIcon;
export default LetterPCircleIcon